import DeviceTable from "layouts/nextus/devicestable";
import LandingPage from "layouts/nextus/landing_page";
import ExploreMap from "layouts/nextus/explore_map";
import ExploreMapEventGroups from "layouts/nextus/explore_map/view_event_groups";
import ExploreMapSubgroups from "layouts/nextus/explore_map/view_subgroups";
import ExploreMapDevices from "layouts/nextus/explore_map/view_devices";

import DeviceView from "layouts/nextus/deviceview";
import DeviceGroups from "layouts/nextus/devicegroups/groups";
import DeviceSubgroups from "layouts/nextus/devicegroups/subgroups"
import DeviceGroupView from "layouts/nextus/devicegroupview";
import Clearways from "modules/clearways/views/clearwaycalendar";
import ClearwaysEditEvent from "modules/clearways/views/Event/Edit";
import ClearwaysAddEvent from "modules/clearways/views/Event/Add";
import ClearwaysViewEvent from "modules/clearways/views/Event/View";

import HelpOnNucleus from "layouts/nextus/nucleushelp";

import CrowdCountingEventEdit from "modules/crowdcounting/views/CrowdCountingEventEdit";
import CrowdCountingEventView from "modules/crowdcounting/views/CrowdCountingEventView";
import CrowdCountingEventList from "modules/crowdcounting/views/CrowdCountingEventList";
import CrowdCountingFudgeMultiplier from "modules/crowdcounting/views/CrowdCountingFudgeMultiplier";

const pageRoutes = [
    {
        short_name: "Landing",
        long_name: "Landing View",
        key: "landing",
        breadcrumb: "",
        icon: "",
        in_menu: false,
        route: "/",
        component: LandingPage,
    },
    // {
    //     short_name: "Map",
    //     long_name: "Explore Map",
    //     breadcrumb: "Map",
    //     icon: "explore",
    //     in_menu: true,
    //     route: "/explore/groups",
    //     component: ExploreMap,
    //     variant: "gradient"
    // },
    {
        breadcrumb: "Map",
        in_menu: false,
        route: "/explore/groups/:group_id",
        component: ExploreMapSubgroups,
    },
    {
        breadcrumb: "Map",
        in_menu: false,
        route: "/explore/groups/:group_id/:subgroup_id",
        component: ExploreMapDevices,
    },
    {
        breadcrumb: "Map",
        in_menu: false,
        route: "/explore/event-groups/:group_ids",
        component: ExploreMapEventGroups,
    },
    // {
    //     short_name: "Devices",
    //     long_name: "View Device List",
    //     breadcrumb: "Devices",
    //     icon: "menu",
    //     in_menu: true,
    //     route: "/devices",
    //     component: DeviceTable,
    //     variant: "gradient"
    // },
    {
        breadcrumb: function (device) {
            return device.name
        },
        in_menu: false,
        route: "/devices/:uuid",
        component: DeviceView
    },
    // {
    //     short_name: "Groups",
    //     long_name: "View Clearway Groups",
    //     breadcrumb: "Groups",
    //     icon: "map",
    //     in_menu: true,
    //     route: "/groups",
    //     component: DeviceGroups,
    //     variant: "gradient"
    // },
    {
        breadcrumb: function (group) {
            return group.group_name
        },
        in_menu: false,
        route: "/groups/:group_id",
        component: DeviceGroupView,
    },
    {
        in_menu: false,
        route: "/groups/:group_id/subgroups",
        component: DeviceSubgroups,
    },
    {
        breadcrumb: function (group) {
            return group.group_name
        },
        in_menu: false,
        route: "/groups/:group_id/subgroups/:subgroup_id",
        component: DeviceGroupView,
    },
    // {
    //     short_name: "Clearways",
    //     long_name: "View Clearway Events",
    //     breadcrumb: "Clearways",
    //     icon: "clearways",
    //     color: "#f8f931",
    //     in_menu: true,
    //     route: "/clearways",
    //     component: Clearways
    // },
    {
        breadcrumb: function (event) {
            return event.name
        },
        in_menu: false,
        route: "/clearways/:event_id",
        component: ClearwaysViewEvent,
    },
    {
        breadcrumb: function (event) {
            return event.name
        },
        in_menu: false,
        route: "/clearways/:event_id/edit",
        component: ClearwaysEditEvent,
    },
    {
        breadcrumb: "New Event",
        in_menu: false,
        route: "/clearways/event",
        component: ClearwaysAddEvent,
    },
    {
        short_name: "crowd_counting",
        long_name: "Crowd Counting", //"Help on Nucleus",
        breadcrumb: "Crowd Counting Events",
        icon: "group",
        in_menu: true,
        route: "/crowds",
        color: "warning",
        variant: "gradient",
        component: CrowdCountingEventList
    },
    {
        short_name: "crowd_counting",
        long_name: "Crowd Counting Event", //"Help on Nucleus",
        breadcrumb: "Event",
        icon: "group",
        in_menu: false,
        route: "/crowds/:event_id",
        color: "warning",
        variant: "gradient",
        component: CrowdCountingEventView
    },
    {
        short_name: "crowd_counting",
        long_name: "Crowd Counting Event Device", //"Help on Nucleus",
        breadcrumb: "Device",
        icon: "group",
        in_menu: false,
        route: "/crowds/:event_id/:uuid",
        color: "warning",
        variant: "gradient",
        component: CrowdCountingEventView
    },
    {
        short_name: "crowd_counting",
        long_name: "Crowd Counting Event", //"Help on Nucleus",
        breadcrumb: "Event",
        icon: "group",
        in_menu: false,
        route: "/crowds/:event_id/edit",
        color: "warning",
        variant: "gradient",
        component: CrowdCountingEventEdit
    },
    {
        short_name: "crowd_counting",
        long_name: "Crowd Counting Event Device", //"Help on Nucleus",
        breadcrumb: "Device",
        icon: "group",
        in_menu: false,
        route: "/crowds/:event_id/edit/:uuid",
        color: "warning",
        variant: "gradient",
        component: CrowdCountingEventEdit
    },
    // {
    //     short_name: "crowd_counting",
    //     long_name: "Crowd Counting", //"Help on Nucleus",
    //     breadcrumb: "Crowd",
    //     in_menu: false,
    //     route: "/crowds/:uuid",
    //     component: CrowdCountingDeviceView
    // },
    // {
    //     short_name: "help",
    //     long_name: "User Assistance", //"Help on Nucleus",
    //     breadcrumb: "Help",
    //     icon: "question_mark",
    //     in_menu: true,
    //     route: "/help",
    //     variant: "gradient",
    //     component: HelpOnNucleus
    // },
    {
        short_name: "fudge_factor",
        long_name: "Crowd Counting fudge factor", //"Help on Nucleus",
        breadcrumb: "Fduge",
        icon: "group",
        in_menu: false,
        route: "/crowds/fudge_factor_mercury_only",
        color: "warning",
        variant: "gradient",
        component: CrowdCountingFudgeMultiplier
    },
    {
        short_name: 'log_out',
        in_menu: true,
        // route: "/clearways/event",
        // component: ClearwaysAddEvent,
    },
];

export default pageRoutes;